import axios from 'axios'
import request from '@/utils/request'
import { getToken } from '@/utils/auth'

export function searchLiterature(params) {
  const timeout = params && params.searchLang === 'en' ? 120000 : 60000
  return request.get('/literature/search', {
    params,
    timeout
  })
}

export function formatLiterature(data) {
  return request.post('/literature/format', data)
}

export function getCitationStyles() {
  return request.get('/literature/citation-styles')
}

export function getReviewQuotaCost() {
  return request.get('/literature/review-cost')
}

export function generateLiteratureReview(data) {
  return request.post('/literature/review', data, { timeout: 180000 })
}

export function exportReviewDocx(data) {
  const token = getToken()
  return axios({
    method: 'post',
    url: '/api/portal/literature/review/export-docx',
    data,
    responseType: 'blob',
    timeout: 60000,
    headers: token ? { Authorization: 'Bearer ' + token } : {}
  })
}
